function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomSharedRoomFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 6a1 1 0 00-1-1H5a1 1 0 00-1 1v23H2V6a3 3 0 013-3h22a3 3 0 013 3v23h-2V6z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 18a2 2 0 10-2 2v2a4 4 0 110-8 4 4 0 010 8v-2a2 2 0 002-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 28c0-4.517 2.157-7.083 3.496-7.864l.864-.503 1.007 1.727-.863.504C8.843 22.25 7 24.118 7 28v1H5v-1zM17 28c0-4.517-2.157-7.083-3.496-7.864l-.864-.503-1.007 1.727.863.504C13.157 22.25 15 24.118 15 28v1h2v-1zM23 18a2 2 0 10-2 2v2a4 4 0 110-8 4 4 0 010 8v-2a2 2 0 002-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 28c0-4.517 2.157-7.083 3.496-7.864l.864-.503 1.007 1.727-.863.504C18.843 22.25 17 24.118 17 28v1h-2v-1zM27 28c0-4.517-2.157-7.083-3.496-7.864l-.864-.503-1.007 1.727.863.504C23.157 22.25 25 24.118 25 28v1h2v-1z",
    fill: props.color
  }));
}

export default SvgIconRoomSharedRoomFilled;